<div class="l-section u-mt-sp-0 u-mt-tb-0 u-mt-pc-40">
  <div class="p-keep-my-fare js-keep-my-fare">
    <div [ngClass]="isKeepMyFare ? 'p-keep-my-fare__box is-open' : 'p-keep-my-fare__box'">
      <div class="p-keep-my-fare__title">
        <div class="c-form-element-toggle">
          <div class="c-form-element-toggle__wrap">
            <input
              type="checkbox"
              id="payment-input-keep-my-fare-toggle-1"
              name="payment-input-keep-my-fare-toggle-1"
              class="c-form-element-toggle__input js-keep-my-fare-btn"
              [attr.aria-expanded]="isKeepMyFare"
              aria-controls="payment-input-keep-my-fare-use-1"
              (click)="this.kmfToggle_x()"
            />
            <label
              id="payment-input-keep-my-fare-use-1"
              for="payment-input-keep-my-fare-toggle-1"
              class="c-form-element-toggle__label"
            >
              <span class="c-form-element-toggle__toggle"></span>
              <span
                class="c-form-element-toggle__label-text u-visually-hidden"
                [innerHTML]="'label.selectKeepMyFare' | staticMsg"
              >
              </span>
            </label>
            <div class="c-form-element-toggle__text">
              <span class="c-text-with-tooltip">
                <span class="c-text-with-tooltip__text" [innerHTML]="'label.selectKeepMyFare' | staticMsg"></span>
                <span class="c-text-with-tooltip__tooltip js-tooltip">
                  <asw-tooltip
                    id="payment-input-keep-my-fare-tooltip-1"
                    iconImage='<img src="assets/images/icon_help_primary_20.svg" width="20" height="20">'
                    [tooltipContent]="'tooltip.keepMyFare' | staticMsg"
                  ></asw-tooltip>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="p-keep-my-fare__contents">
        <p
          [innerHTML]="
            'message.KeepMyFare'
              | staticMsg
                : {
                    '0': this.totalPriceOfKeepMyFare | amountFormat : undefined : this.KeepMyFareCurrencyCode,
                    '1': this.numberOfTravelers
                  }
          "
        ></p>
      </div>
    </div>
  </div>
</div>
